import {
  ref,
  defineCustomElement,
} from 'vue';
import AppShadowContent from '@/shared/components/AppPersonalAgreementDialog/AppShadowContent.vue';

export const closeFromInsideModal = ref(0);

export const aliveFancyboxClose = () => {
  setTimeout(() => {
    if (!window?.$?.fancybox) {
      if (!window.$) {
        window.$ = {};
      }
      window.$.fancybox = {
        close() {
          closeFromInsideModal.value += 1;
        },
      };
    }
  });
};
aliveFancyboxClose();

const CustomElement = defineCustomElement(AppShadowContent);
window.customElements.define('my-shadow-content', CustomElement as any);
